import axios from '@/libs/api.request'

export const getOrderList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/order'
  })
}

export const getOrderInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/order/' + id
  })
}

export const getOrderExcel = (params) => {
  return axios.request({
    method: 'get',
    url: '/order/export',
    params
  })
}

export const getCoinRechargeList = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/finance/coin/recharged/query'
  })
}

export const getVipActiveList = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/finance/order/vip/active'
  })
}

export const getCoinRechargeListExport = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/finance/coin/recharged/query/export'
  })
}

export const getVipActiveListExport = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/finance/order/vip/active/export'
  })
}
